import Cookies from 'js-cookie'
import createNewId from '@/utils/random-id'
import env from '@/constants/env'

const { PUBLIC_STATSIG_CLIENT_KEY, PUBLIC_ENV_CONTEXT } = env

export type SendEventToStatsigFunction = (
  event: string,
  payload?: { [key: string]: string | number | object | undefined } | undefined,
  value?: string | undefined,
) => void

export const sendEventToStatsig: SendEventToStatsigFunction = async (
  event,
  payload = {},
  value = undefined,
) => {
  try {
    if (!window.statsigClient) return

    const eventData: {
      eventName: string
      metadata: { [key: string]: string | number | object | undefined } | undefined
      value?: string
    } = {
      eventName: event,
      metadata: payload,
    }
    if (value) {
      eventData.value = value
    }

    window.statsigClient.logEvent(eventData)
    await window.statsigClient.flush()
  } catch (error) {
    console.log(`FAILED STATSIG EVENT DATA: ${event}`, payload)
    console.error('STATSIG ERROR:', error)
  }
}

export const sendHTTPEventToStatsig = async (
  eventKey: string,
  _eventValue: string | null = null,
  metadata: { [key: string]: string | undefined } = {},
) => {
  const userID = Cookies.get('statsig-user-id') ?? createNewId()
  const userObject = {
    userID,
    statsigEnvironment: { tier: PUBLIC_ENV_CONTEXT },
  }

  await fetch('https://events.statsigapi.net/v1/log_event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'statsig-api-key': PUBLIC_STATSIG_CLIENT_KEY },
    body: JSON.stringify({
      events: [{ user: userObject, eventName: eventKey, metadata: metadata }],
    }),
  })
}
